export default __webpack_public_path__ + "static/AgrandirRegular-13a9124076963b1a82c7e95f62f18815.woff";